import map from 'lodash/map';
import union from 'lodash/union';
import without from 'lodash/without';
import { rejected, resolved } from 'store/createAction';
import {
  ARCHIVE_ALL_CONVERSATIONS,
  ARCHIVE_CONVERSATIONS,
  GET_CONVERSATIONS,
  GET_NEW_MESSAGE_COUNT,
  GET_UNACTIONED_CONVO_INBOX,
  OPTED_OUT_CONVO,
  UPDATE_CONVERSATION,
  UPDATE_CONVERSATIONS,
} from '../types';

const initialState = {
  loading: false,
  hasMore: true,
  ids: [], // conversation ids by getId function
  limit: 30,
  offset: 0,
  unread: 0,
};

const getId = (convo) => convo.inbox_id + ':' + convo.contact.hash;

export default (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case GET_CONVERSATIONS:
      return {
        ...state,
        loading: true,
      };
    case resolved(GET_CONVERSATIONS): {
      if (meta.reset) {
        return {
          ...state,
          loading: false,
          ids: map(payload, getId),
          offset: meta.query.offset,
          hasMore: payload.length === meta.query.limit,
        };
      }
      const newIds = map(payload, getId);
      return {
        ...state,
        loading: false,
        ids: union(state.ids, newIds),
        offset: meta.query.offset,
        hasMore: payload.length === meta.query.limit,
      };
    }

    case rejected(GET_CONVERSATIONS):
      return {
        ...state,
        loading: false,
        hasMore: false,
      };

    case resolved(UPDATE_CONVERSATION): {
      const key = meta.inboxId + ':' + meta.convoId;
      if (payload.inbox_item_archived === '1') {
        return {
          ...state,
          ids: state.ids.filter((i) => i !== key),
        };
      }
      return {
        ...state,
        ids: union(state.ids, [key]),
      };
    }

    case resolved(UPDATE_CONVERSATIONS): {
      if (!payload.length) {
        return state;
      }
      let newIds = state.ids;
      payload.forEach((c) => {
        const k = getId(c);
        if (c.inbox_item_archived === '1') {
          newIds = newIds.filter((i) => i !== k);
          // filtering all inbox too
          newIds = newIds.filter((i) => i !== `all:${c.contact.hash}`);
        }
      });
      return {
        ...state,
        ids: newIds,
      };
    }

    case OPTED_OUT_CONVO: {
      return {
        ...state,
        ids: state.ids.filter((i) => i !== payload),
      };
    }

    case resolved(ARCHIVE_ALL_CONVERSATIONS): {
      return {
        ...state,
        ids: [],
        hasMore: false,
      };
    }

    case resolved(ARCHIVE_CONVERSATIONS): {
      const idsToUpdate = [];
      payload.forEach((i) => {
        idsToUpdate.push(getId(i));
        idsToUpdate.push(`all:${i.contact.hash}`);
      });
      return {
        ...state,
        ids:
          meta.status === '0'
            ? union(state.ids, idsToUpdate)
            : without(state.ids, ...idsToUpdate),
      };
    }

    case resolved(GET_NEW_MESSAGE_COUNT): {
      return {
        ...state,
        unread: payload.inbox,
      };
    }
    case resolved(GET_UNACTIONED_CONVO_INBOX): {
      return {
        ...state,
        unread: payload,
      };
    }
    default:
      return state;
  }
};
